exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MailContactImage1-a{display:block;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/MailContactImage1/MailContactImage1.scss
// module id = 1039
// module chunks = 21